var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.1819 10.3536L11.7677 11.7678C11.7677 11.7678 10.9191 11.6264 9.64633 10.3536C8.37354 9.08077 8.23212 8.23224 8.23212 8.23224L9.64633 6.81803L8.23212 2.57539L4.34303 2.92894C4.34303 2.92894 2.39849 8.05547 7.17146 12.8284C11.9444 17.6014 17.071 15.6569 17.071 15.6569L17.4245 11.7678L13.1819 10.3536Z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

PhoneInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
